// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"350600e5","371":"b09df92a","407":"2ca659ed","484":"b966d795","609":"87493e20","624":"aca7899c","703":"31ded1d4","722":"72e04882","791":"506c8ea3","799":"4744dbf2","921":"e55b2e91","953":"caaa5d9c"}[chunkId] + ".chunk.js";
};